import {
  PayeeRequirement,
  RequirementType
} from "@wingspanhq/wingspan-api-sdk";
import { EmployeeTaxFormsMetadata } from "../helpers/getEmployeeTaxFormsProgress";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getEmployeeTaxFormsRequirementName } from "../helpers/getEmployeeTaxFormsRequirementName";
import { getEmployeeTaxFormsStatusCell } from "../helpers/getEmployeeTaxFormsStatusCell";

/**
 * Company-facing config (RequirementContextType.Payee — the payer reviewing a
 * contractor's requirement). Read-only cells; the payer's "Mark incomplete"
 * action comes from the shared Requirements default actions
 * (useRequirementDefaultActions → PATCH /requirement/:id). For an
 * EmployeeTaxForms requirement, that PATCH is a sticky payer override
 * (applyPayerOverrides sets payerOverrideStatus: Incomplete; requirement.status
 * reflects it). The contractor's completed filings are NOT invalidated — a
 * forms-service reset is deferred per review — so dataSourceStatus stays
 * Complete. The payer clears the override by marking the requirement complete
 * again.
 */
export const usePayeeEmployeeTaxFormsConfig = (
  _callback: RequirementTableCallback
): CellsConfig<PayeeRequirement, ContextItem, EmployeeTaxFormsMetadata> => {
  return {
    isActionRequired: () => false,

    requirementName: getEmployeeTaxFormsRequirementName,

    toolbarActions: () => [],

    nameCell: requirement => ({
      text: getEmployeeTaxFormsRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type as RequirementType
      }),

    statusCell: (requirement, _context, metadata) =>
      getEmployeeTaxFormsStatusCell(requirement, metadata),

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
